import { createAction } from '@reduxjs/toolkit'

import { AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_BEGIN } from './action-types'

export type FetchAgencyCascadeSchedulingPlanPayload = { planId: number }

export const fetchAgencyCascadeSchedulingPlan = createAction<FetchAgencyCascadeSchedulingPlanPayload>(
  AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_BEGIN,
)

export type FetchAgencyCascadeSchedulingPlanAction = ReturnType<typeof fetchAgencyCascadeSchedulingPlan>
